module.exports = __webpack_public_path__ + "aa975cab353342bfed4080a5fcbc0ce2.png";


//////////////////
// WEBPACK FOOTER
// ./components/atoms/button/active.png
// module id = cgEI
// module chunks = 10